module.exports = __webpack_public_path__ + "static/img/10ko.1fb7754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/10ko.jpg
// module id = 3Iqo
// module chunks = 0